import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { Callout, CalloutVariant } from "../../../Callout";
import { Email as EmailIcon } from "@mui/icons-material";
import { Fmt } from "../../../../formatters";
import { usePrimaryOrganization } from "../../../../hooks/useOrganization";
import { DataRequestCustomFieldDisplay } from "../DataRequestCustomFieldDisplay";

type Props = {
  request: DataRequestDetail;
};

export const NoWorkflowRequestSteps: React.FC<Props> = ({ request }) => {
  const [org] = usePrimaryOrganization();
  const fullName = Fmt.DataSubject.fmtFullName(request);

  return (
    <>
      {request.emailVerified && (
        <Callout icon={EmailIcon} variant={CalloutVariant.Green} className="mb-std w-640">
          <p>{`${fullName}'s`} email has been verified by TrueVault.</p>
        </Callout>
      )}

      <DataRequestCustomFieldDisplay org={org} request={request} classList="mb-md" />
    </>
  );
};
